import axios from 'axios';

type DeleteConfigContactParams = {
  listingId: string;
  contactId: string;
};

const deleteConfigContact = async (params: DeleteConfigContactParams) => {
  const { data } = await axios.post(
    `/appointments/${params.listingId}/config/contacts/deleteContact/${params.contactId}`,
  );

  return data;
};

export default deleteConfigContact;
